import { createFileRoute } from "@tanstack/react-router";

import { PersonalAccessTokensPanel } from "@/features/preferences/personal-access-tokens/personal-access-tokens-panel";

export const Route = createFileRoute("/_authenticated/preferences")({
  component: PreferencesPage,
});

function PreferencesPage() {
  return (
    <div className="flex flex-col gap-8">
      <div>
        <h2 className="text-2xl font-semibold tracking-tight">Preferences</h2>
        <p className="text-muted-foreground text-sm">
          Account settings for Compass.
        </p>
      </div>
      <PersonalAccessTokensPanel />
    </div>
  );
}
